<template>
	<div ref="slide10" class="slide_10 zoom" v-parallax-fit="parallax"></div>
</template>

<script>
import { store } from '../../store';

export default {
	name: 'slide10',
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},

	mounted() {
		let ticking = false;
		const scrollStatus = this.$scrollStatus;
		const slideRef = this.$refs.slide10;
		const audio = '/themes/rise-theme/resources/assets/audio/vanessa/2.mp3';
		document.addEventListener('scroll', function (e) {
			if (!ticking) {
				window.requestAnimationFrame(function () {

					if (scrollStatus.scrollPosition > 7100 && scrollStatus.scrollPosition < 9600) {
						slideRef.style.animationPlayState = 'running';
					} else {
						slideRef.style.animationPlayState = 'paused';
					}

					ticking = false;
				});

				ticking = true;
			}
		});
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/5a.jpg',
					url: 'https://www.fullstackeconomics.com/p/the-2000s-housing-bubble-was-greatly-exaggerated',
					link_title: {
						'en': 'The 2000s housing bubble was greatly exaggerated',
						'es': 'La burbuja inmobiliaria de la década de 2000 fue muy exagerada'
					}
				},
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/5b.jpg',
					url: 'https://www.americanprogress.org/article/2008-housing-crisis/',
					link_title: {
						'en': 'The 2008 Housing Crisis',
						'es': 'La crisis de la vivienda de 2008'
					}
				}
			],
			text: {
				'en': 'An analysis by Robert Shiller, more than a decade after the 2008 financial crisis, points to the shortage of housing that contributed to home prices going up in the late 2000s. We continue to be impacted by the severe downturn of home building after the recession. Policymakers failure to regulate financial market speculation with investors also continues to drive up prices and crowd out families looking for a home to buy or rent.',
				'es': 'Un análisis de Robert Shiller, más de una década después de la crisis financiera de 2008, apunta a la escasez de viviendas que contribuyó a que los precios de las viviendas subieran a finales de la década de 2000. Seguimos afectados por la grave caída de la construcción de viviendas después de la recesión. El hecho de que los legisladores no regulen la especulación del mercado financiero con los inversionistas también continúa elevando los precios y desplazando a las familias que buscan una casa para comprar o alquilar.'
			}
		};

		const text = {
			'en': 'Even today, the causes of the 2008 financial crisis continue to be debated. Did low interest rates cause homes to be overvalued leading to a bubble? What about all that predatory lending and those unregulated financial products? What we do know is that a financial crisis that started in the real estate sector caused a global economic recession for years to come, with many families deeply impacted.',
			'es': 'Incluso hoy, las causas de la crisis financiera de 2008 continúan siendo objeto de debate. ¿Las bajas tasas de interés causaron que las casas estuvieran sobrevaluadas, lo que llevó a una burbuja? ¿Qué pasa con todos esos préstamos depredadores y esos productos financieros no regulados? Lo que sí sabemos es que una crisis financiera que comenzó en el sector inmobiliario provocó una recesión económica mundial en los próximos años, con muchas familias profundamente afectadas.'
		};
		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.top == '150px') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
					this.$readMore.value = text;
					this.$evidence.value = JSON.stringify(evidence);
				}
			});
		});

		this.mutationObserver.observe(document.querySelector('#slide10'), {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/vanessa/2.srt',
				'es': '/themes/rise-theme/resources/assets/audio/vanessa/2_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 7200,
					end: 8000,
					fromStyle: { top: '-900px' },
					toStyle: { top: '150px' },
					easing: 'linear'
				},
				{
					start: 9000,
					end: 9600,
					fromStyle: { top: '150px' },
					toStyle: { top: '2000px' },
					easing: 'linear'
				},
			]
		};
	}
}
</script>

<style lang="scss">
.slide_10 {
	position: absolute;
	transform-origin: center;
	background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/10_Brain.png');
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	width: 450px;
	height: 500px;
	left: -230px;
	top: 0px;
	transition: 0.6s;
	z-index: 5;
	animation-duration: 2s;
	animation-iteration-count: infinite;
	animation-name: heart_pump;
	animation-play-state: running;

	@media(min-width: 600px) and (max-width: 1280px) {
		zoom: 0.65;
	}

	@media(max-width: 600px) {
		width: 300px;
		left: -100px;
	}
}

@keyframes heart_pump {
	0% {
		transform: scale(1) rotateZ(12deg);
	}

	25% {
		transform: scale(.97) rotateZ(12deg);
	}

	35% {
		transform: scale(.9) rotateZ(12deg);
	}

	45% {
		transform: scale(1.1) rotateZ(12deg);
	}

	55% {
		transform: scale(.9) rotateZ(12deg);
	}

	65% {
		transform: scale(1.1) rotateZ(12deg);
	}

	75% {
		transform: scale(1.03) rotateZ(12deg);
	}

	100% {
		transform: scale(1) rotateZ(12deg);
	}
}
</style>
